module.exports = __webpack_public_path__ + "static/dimensional_shackles-d7fddd4e22b9e92be61ac8a0aebc8433.jpeg";